import tagNav from './tagNav';
// import permission from "./permission";
import app from './app';
import permissionPlus from './permissionPlus';

export default { tagNav, app, permissionPlus };